export default __webpack_public_path__ + "scripts/resources/assignments/en/kinetics/cv_bleaching/spectra.json";